export const state = {
  documentToRename: {},
  isOpen: false,
  loading: false,
}
